export enum LoginType {
    Username, AAD, Both
}